<template>
  <main class="c-main">
    <div class="">
      <div class="card">
        <header class="card-header d-flex g-5">
          <button
            class="btn btn-primary"
            :class="{ 'btn-dark': currentStatus == null }"
            @click="getSuggestions({ status: null, page: 1 })"
          >
            Все
          </button>
          <button
            class="btn btn-info"
            :class="{ 'btn-dark': currentStatus == 0 }"
            @click="getSuggestions({ status: 0, page: 1 })"
          >
            Требующие действия
          </button>
          <button
            class="btn btn-success"
            :class="{ 'btn-dark': currentStatus == 1 }"
            @click="getSuggestions({ status: 1, page: 1 })"
          >
            Подтвержденные
          </button>
          <button
            class="btn btn-danger"
            :class="{ 'btn-dark': currentStatus == 2 }"
            @click="getSuggestions({ status: 2, page: 1 })"
          >
            Отмененные
          </button>
          <h4 class="pull-right ml-auto">
            Предложения отправленные с tasniflagich.mf.uz
          </h4>
        </header>
        <div class="card-body">
          <div class="d-flex flex-column justify-content-between w-100">
            <div class="d-flex">
              <div class="form-group mr-4">
                <date-picker
                  class="w-100"
                  v-model="beginDate"
                  valueType="YYYY-MM-DD HH:mm:ss"
                  placeholder="Дата с"
                ></date-picker>
              </div>
              <div class="form-group mr-4">
                <date-picker
                  class="w-100"
                  v-model="endDate"
                  valueType="YYYY-MM-DD HH:mm:ss"
                  placeholder="Дата до"
                ></date-picker>
              </div>

              <div class="form-group">
                <button class="btn btn-success" @click="downloadExcel()">
                  Экспорт
                </button>
              </div>
            </div>
            <div class="d-flex">
              <div class="form-group mr-4">
                <input
                  type="text"
                  class="form-control"
                  v-model="phone"
                  placeholder="Номер телефона"
                />
              </div>
              <div class="form-group mr-4">
                <input
                  type="email"
                  class="form-control"
                  v-model="email"
                  placeholder="Электронная почта"
                />
              </div>
              <div class="form-group">
                <button class="btn btn-success" @click="handleSuggestionFilter">
                  Фильтр
                </button>
              </div>
            </div>
          </div>
          <table
            class="table table-bordered table-striped"
            id="serverDataTable"
          >
            <thead>
              <tr>
                <th>id</th>
                <th>номер</th>
                <th>маил</th>
                <th>название товара</th>
                <th>дата отправки</th>
                <th>Действие</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(s, index) in suggestions" :key="index">
                <td>{{ s.id }}</td>
                <td>{{ s.phone }}</td>
                <td>{{ s.email }}</td>
                <td>{{ s.productName }}</td>
                <td>{{ $moment(s.created_at).format("DD-MM-YYYY") }}</td>
                <td class="d-flex g-5">
                  <button
                    class="btn btn-primary"
                    @click="openViewSugModal(s.id)"
                  >
                    Посмотреть
                  </button>
                  <button
                    class="btn btn-success"
                    @click="openUpdateSugModal(s.id)"
                  >
                    Действие
                  </button>
                </td>
              </tr>
            </tbody>
          </table>
          <div class="row d-flex justify-content-center">
            <paginate
              v-model="pagination.page"
              :page-count="pagination.count"
              :page-range="3"
              :margin-pages="2"
              :click-handler="getCurrentPage"
              :current="pagination.page + 1"
              :prev-text="'<'"
              :next-text="'>'"
              :container-class="'pagination'"
              :page-class="'page-item'"
              :page-link-class="'page-link-item'"
              :prev-class="'prev-pagination'"
              :prev-link-class="'prev-link-pagination'"
              :next-class="'next-pagination'"
              :next-link-class="'next-link-pagination'"
            ></paginate>
          </div>
        </div>
      </div>
    </div>
    <SuggestionsModal
      v-if="showSugViewModal && single_suggestion"
      @closeModal="closeSugViewModal"
      :suggestion="single_suggestion"
    />
    <UpdateSugModal
      v-if="showUpdateSugModal && single_suggestion"
      @closeModal="closeSugUpdateModal"
      :suggestion="single_suggestion"
    />
  </main>
</template>

<script>
import { GET, DELETE, POST } from "../../shared/api";
import SuggestionsModal from "./SuggestionModal.vue";
import UpdateSugModal from "./UpdateSugModal.vue";
export default {
  data() {
    return {
      beginDate: null,
      endDate: null,
      phone: "+998",
      email: null,
      currentStatus: null,
      suggestions: [],
      showSugViewModal: false,
      showUpdateSugModal: false,
      single_suggestion: null,
      pagination: {
        page: 0,
        perpage: 10,
        count: 0,
        mode: 0,
      },
    };
  },
  components: { SuggestionsModal, UpdateSugModal },
  methods: {
    downloadExcel() {
      GET(
        {
          status: this.currentStatus,
          created_from: this.beginDate || "",
          created_to: this.endDate || "",
        },
        "suggestions/export",
        this,
        false,
        true,
        true
      )
        .then((res) => {
          const blob = new Blob([res.data], {
            type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
          });

          const url = window.URL.createObjectURL(blob);
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute("download", "product_suggestions.xlsx");
          document.body.appendChild(link);
          link.click();
          link.remove();
          window.URL.revokeObjectURL(url);
        })
        .catch((error) => {
          console.error("Yuklab olishda xatolik:", error);
        });
    },
    getSuggestions(query) {
      this.currentStatus = query.status;
      this.pagination.page = query.page;
      GET(
        {
          ...query,
          status: this.currentStatus,
          perpage: this.pagination.perpage,
        },
        "/suggestions",
        this,
        false
      ).then((response) => {
        this.suggestions = response.data.data;
        this.pagination.page = response.data.page + 1;
        this.pagination.count = Math.ceil(
          response.data.total / this.pagination.perpage
        );
      });
    },
    getCurrentPage(pageNumber) {
      this.pagination.page = pageNumber;
      GET(
        { ...this.pagination, status: this.currentStatus },
        "/suggestions",
        this,
        false
      ).then((response) => {
        this.suggestions = response.data.data;
        this.pagination.page = response.data.page + 1;
        this.pagination.count = Math.ceil(
          response.data.total / this.pagination.perpage
        );
      });
    },
    openViewSugModal(id) {
      this.showSugViewModal = true;
      this.single_suggestion = this.suggestions.find((s) => s.id == id);
    },
    closeSugViewModal(value) {
      this.showSugViewModal = value;
      this.single_suggestion = null;
    },
    openUpdateSugModal(id) {
      this.showUpdateSugModal = true;
      this.single_suggestion = this.suggestions.find((s) => s.id == id);
    },
    closeSugUpdateModal(value) {
      this.showUpdateSugModal = value;
      this.single_suggestion = null;
      this.getSuggestions({
        status: this.currentStatus,
        ...this.pagination,
      });
    },
    handleSuggestionFilter() {
      const params = {
        status: this.currentStatus,
        page: 1,
        perpage: 10,
        phone: this.phone,
        email: this.email,
      };
      if (!this.phone) delete params.phone;
      if (!this.email) delete params.email;

      this.getSuggestions(params);
    },
  },
  mounted() {
    this.getSuggestions({
      status: 0,
      page: 1,
      perpage: 10,
      ...this.pagination,
    });
  },
};
</script>
